#import "./TripFragment.graphql"
#import "../../../../list/TravelSectionAuthDataFragment.graphql"
#import "../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation TripCreate($input: TripCreateInput!) {
  tripCreate(input: $input) {
    trip {
      id
      travelerId
      _isDeletable
      _rowTimestamp
      travelerReferenceName
      traveler {
        id
        _fullName
        _isUpdatable
        _pickupAddress
        isEconomyClassPreferred
        isBusinessClassPreferred
        isFirstClassPreferred
        vendorNumber
        _isApproved
        travelPolicy {
          id
          isCompanion
          description
          isContractual
          isDefaultCustomizable
          companyCurrency {
            isoCode
          }
        }
        _travelPolicyAllowances(
          orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
        ) {
          nodes {
            id
            expenditureType {
              expenditureType
            }
            allowanceOverrideAmount
            _allowanceDescription
            isAllowanceCustomizable
            _travelerPolicyAllowanceRowTimestamp
            _travelerPolicyAllowanceId
          }
        }
      }
      accountReference
      trainAmount
      incidentalAmount
      otherAmount
      budgetAmount
      controlTotalAmount
      airfareAmount
      accommodationAmount
      vehicleRentalAmount
      transportationAmount
      specialInstructions
      comments
      _isOverBudget
      tripLocator
      travelAuthorizationId
      travelAuthorization {
        _isPlanningPhase
        currency {
          id
          isoCode
          currencySymbol
        }
      }
      warningInfo1
      warningInfo2
      warningInfo3
      warningValue1
      warningValue2
      warningValue3
      tripItems {
        nodes {
          ...TripItemFragment
        }
      }
      _requiredApprovalDocuments
      _isApprovalDocumentsRequired
      entityDocumentsByEntityId(
        orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
      ) {
        nodes {
          ...EntityDocumentsFields
        }
        totalCount
      }
      tripHistoriesByEntityId {
        nodes {
          crudOperation
          pointInTimeDate
          tenantUserName
        }
      }
      notesByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          id
          _createdByUserName
          _createdDate
          noteComment
          isShared
          _isUpdatable
          _rowTimestamp
          _isDeletable
        }
      }
    }
    travelAuthorization {
      __typename
      id
      _travelerReference
      stampedEntityDocumentId
      _isApprovalRevocable
      _isStagedApprovalRequest
      isDraft
      requiredDate
      requiredTime
      _rowTimestamp
      _isUpdatable
      _isDeletable
      budgetAmount
      controlTotalAmount
      isDraft
      requiredDate
      _isOverBudget
      requiredTime
      _requiredApprovalDocuments
      _isPlanningPhase
      trips(orderBy: [TRAVELER_REFERENCE_NAME_ASC , TRIP_LOCATOR_ASC]) {
        nodes {
          id
          _rowTimestamp
          tripLocator
          travelerReferenceName
          accountReference
          airfareAmount
          accommodationAmount
          transportationAmount
          vehicleRentalAmount
          trainAmount
          incidentalAmount
          otherAmount
          controlTotalAmount
          _isOverBudget
          budgetAmount
        }
      }
      ...TravelAuthorizationTravelSectionFragment
    }
  }
}
